export const color = {
  focusColor: '#009cc2',

  redBrand01: '#ed0007',
  redBrand02: '#d50005',
  redBrand03: '#a80003',

  turquoise01: '#00c8f7',
  turquoise02: '#00b9e5',
  turquoise03: '#009cc2',
  turquoise04: '#00738f',
  turquoise05: '#004d61',
  turquoise06: '#002936',

  grey01: '#edf1f4',
  grey02: '#cad6dd',
  grey03: '#a3bac8',
  grey04: '#99aebb',
  grey05: '#7995a6',
  grey06: '#506e81',
  grey07: '#476273',
  grey08: '#354956',
  grey09: '#2d3e48',
  grey10: '#1c272e',

  green01: '#d9e8d0',
  green02: '#528236',
  green03: '#1a2a11',

  yellow01: '#f9f3bc',
  yellow02: '#ebd417',
  yellow03: '#2a2604',

  red01: '#f7bfc8',
  red02: '#da1e28',
  red03: '#54000e',

  orange01: '#FBE8DA',
  orange02: '#DC641E',

  darkBlue01: '#d1dce3',
  darkBlue02: '#002b49',
  darkBlue03: '#00243e',

  white: '#ffffff',
  black: '#000000',
};

export type TColor = keyof typeof color;
export type TBGColor = 'grey01' | 'turquoise01' | 'darkBlue02';
